import React from 'react';
import MessageReactionSelector from './MessageReactionSelector';
import MessageThreeDots from './MessageThreeDots';
import MessageStar from './MessageStar';

const MessageHoverActionContainer = (props) => {
    return (
        <div
            className="d-flex flex-col justify-content-center align-items-end dropper "
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <div></div>
            <div
                className="d-flex flex-row"
                style={{
                    height: 'fit-content',
                    cursor: 'pointer',
                    transition: 'box-shadow 0.2s ease',
                    borderRadius: '14px',
                    padding: '4px',
                    margin: '0 4px',
                    zIndex: 10,
                    backgroundColor: '#F5F5F5',
                    boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px',
                }}
            >
                {props?.roomType || props?.subChannelType ? <MessageReactionSelector {...props} /> : null}
                {props?.roomType || props?.subChannelType ? <MessageStar {...props} /> : null}
                <MessageThreeDots {...props} />
            </div>
        </div>
    );
};

export default MessageHoverActionContainer;
